export enum Layer {
  Alert = 100,
  Header = 99
}